import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PaceOfflineFeatureState } from '../store/state';

export interface OfflineStrategy {
    getState(): Observable<PaceOfflineFeatureState | undefined>;
    setState(state: PaceOfflineFeatureState): Observable<boolean>;
    deleteCache(): Observable<boolean>;
}

export const OfflineStrategyInjectionToken = new InjectionToken<OfflineStrategy>('PaceOfflineStrategy');
